import { Spacing } from "@vkontakte/vkui";
import { UIButton } from "../UIButton/UIButton";
import s from "./style.module.scss";
import FLLogo from "@/assets/fl.webp";
import { getAuthLink } from "@/core/api/requests/getAuthLink";
import { openLink, miniApp } from "@telegram-apps/sdk-react";

export const Auth = () => {
  const handleClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    const link = await getAuthLink();
    openLink(link);
    miniApp.close();
  };
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.fl_logo}>
          <img src={FLLogo} alt="FL.ru" />
          <span>FL.ru</span>
        </div>
        <Spacing size={20} />
        <div className={s.text}>
          Авторизируйтесь <br /> в профиле через FL.ru
        </div>
        <Spacing size={10} />
        <div className={s.subtext}>
          Авторизация необходима для оформления <br /> заказов, просмотра
          заказанных услуг и <br /> синхронизации с FL.RU
        </div>
      </div>
      <UIButton className={s.button} fontType="primary-2" onClick={handleClick}>
        Войти как заказчик через Fl.ru
      </UIButton>
    </div>
  );
};
